import { environment } from '../../../environments/environment';
export let isDebugMode = environment.isDebugMode;
const noop = () => undefined;
const ɵ0 = noop;
export class ConsoleLoggerService {
    get info() {
        if (isDebugMode) {
            return console.info.bind(console);
        }
        else {
            return noop;
        }
    }
    get warn() {
        if (isDebugMode) {
            return console.warn.bind(console);
        }
        else {
            return noop;
        }
    }
    get error() {
        return console.error.bind(console);
    }
    invokeConsoleMethod(type, args) {
        const logFn = (console)[type] || console.log || noop;
        logFn.apply(console, [args]);
    }
}
export { ɵ0 };
